import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Card, Button, Table, Tooltip, Select, Input, Modal, Tag, message, Alert } from 'antd'
import { PAGE_SIZE, SORT_FIELD_NAME, SORT_UP_DOWN } from '../../utils/contrains'
import { getNowAcademicYear, getNowAcademicSemester } from '../../utils/dateUtil'
import { formateDate } from '../../utils/dateUtil'

import { req_list_ccw_theme, req_page_ccw_works, req_delete_ccw_works, req_add_ccw_haviorLog } from '../../api'
import memoryUtils from '../../utils/memoryUtils'

import CulturalcreativeWorksShowModal from '../culturalcreativeworks/culturalcreative-works-show-modal'
class AchievementWorks extends Component {

    // 基礎通用參數 //////////////////////////////////////////////    
    state = {
        deviceWidth: 0,
        loading: false,
        userLevel: 'STANDARD',
        items: [],
        item: {},
        pagination: {
            current: 1,
            pageSize: PAGE_SIZE,
            total: 0
        },
        columnSort: SORT_FIELD_NAME,
        orderBy: SORT_UP_DOWN,
        searchField: 'NONE',
        searchValue: '',
        filterStatus: '',

        domnloadFile: '',

        nowAcademicYear: getNowAcademicYear(new Date()),
        nowAcademicSemester: getNowAcademicSemester(new Date()),

        isShowModal: false,

        options: []
    }

    UNSAFE_componentWillMount() {
        this.api_list_options()
        this.init_columns()
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
        this.api_page_items(1)
    }

    componentWillUnmount(){
        window.removeEventListener("resize", this.resize.bind(this))
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_page_items = async (current) => {
        const { pageSize } = this.state.pagination
        const { searchField, searchValue, columnSort, orderBy, filterStatus } = this.state
        const { token, userCode } = this.props.user

        this.setState({ loading: true, items: [] })
        const result = await req_page_ccw_works(userCode, this.state.userLevel, current, pageSize, columnSort, orderBy, searchField, searchValue, filterStatus, token)
        //console.log(result);
        if (result.total > 0) {
            const { total } = result
            const items = result.data
            const pagination = { current: this.current, pageSize: this.state.pagination.pageSize, total }
            this.setState({ items, pagination })

        } else {
            const items = []
            const pagination = { current: 1, pageSize: this.state.pagination.pageSize, total: 0 }
            this.setState({ items, pagination })
        }
        this.setState({ loading: false })
    }


    api_delete_item = async (key) => {
        const { token } = this.props.user
        const result = await req_delete_ccw_works(key, token)

        if (result.status === 'success') {
            message.success('刪除成功')
            this.api_page_items(this.current)
        } else {
            //console.log(result)
        }
    }

    api_add_view_log = async (item) => {
        const { token, userCode, userName } = this.props.user
        const { ObjectCollectionNid } = item
        const log = {
            HaviorType: 'SEEN',
            OperatorCode: userCode,
            OperatorName: userName,
            ObjectCollectionNid: ObjectCollectionNid,
            Description: ''
        }
        await req_add_ccw_haviorLog(log, token)
    }

    api_list_options = async () => {
        const options = await req_list_ccw_theme()
        this.setState({ options })
    }
    // 數據配置設定 ////////////////////////////////////////////// 

    init_columns = () => {
        this.columns = [
            {
                title: '作者姓名',
                dataIndex: 'ObjectOwnerName',
                width: 20,
            },
            {
                title: '作品名稱',
                dataIndex: 'ObjectCollectionName',
                width: 60,
                render: (field) => {
                    return (
                        <div>
                            <span style={{ fontSize: '1.3em' }}> {field}</span>
                        </div>
                    )
                },
            },
            {
                title: '建檔時間',
                width: 20,
                responsive: ['md'],
                render: (item) => {
                    const { RecordCreateDateTime } = item
                    return (
                        <>{formateDate(RecordCreateDateTime)}</>
                    )
                },

            },
            {
                title: '分類',
                width: 60,
                responsive: ['md'],
                render: (item) => {
                    const { CreativeCommonsLicense, IsOriginality, ObjectType, IsPublic } = item
                    return (
                        <>
                            <Tag color={this.style_switch_color_tag('PUBLIC', IsPublic)}>{this.style_switch_text_tag('PUBLIC', IsPublic)}</Tag>
                            <Tag color={this.style_switch_color_tag('TYPE', ObjectType)}>{this.style_switch_text_tag('TYPE', ObjectType)}</Tag>
                            <Tag color={this.style_switch_color_tag('ORIGINAL', IsOriginality)}>{this.style_switch_text_tag('ORIGINAL', IsOriginality)}</Tag>
                            <Tag color={this.style_switch_color_tag('LICENSE', CreativeCommonsLicense)}>{this.style_switch_text_tag('LICENSE', CreativeCommonsLicense)}</Tag>
                        </>
                    )
                },
            },
            {
                title: '',
                dataIndex: '',
                width: 40,
                render: (item) => {
                    return (
                        <>
                            <button type="button" className="btn btn-outline-dark btn-sm" onClick={() => this.handle_show_ui_modal('view', item)}><i className="far fa-eye"></i><span style={{ marginLeft: '2px' }}>  瀏覽</span></button>
                        </>
                    )
                },

            }
        ]
    }

    style_switch_text_tag(name, value) {
        let ans = '其他'
        switch (name) {
            case 'LICENSE':
                switch (value) {
                    case 'BOTH':
                        ans = '無限制'
                        break;
                    case 'BYNCSA':
                        ans = '非商業性分享'
                        break;
                    case 'COPYRIGHT':
                        ans = '版權所有'
                        break;
                    default:
                        // OTHER
                        break;
                }
                return ans
            case 'TYPE':
                switch (value) {
                    case 'OTHER':
                        ans = '其它'
                        break;
                    case '2D':
                        ans = '平面'
                        break;
                    case '3D':
                        ans = '立體'
                        break;
                    default:
                        // OTHER
                        break;
                }
                return ans
            case 'ORIGINAL':
                switch (value) {
                    case 'BOTH':
                        ans = '其它'
                        break;
                    case 'NO':
                        ans = '非原創'
                        break;
                    case 'YES':
                        ans = '原創'
                        break;
                    default:
                        // OTHER
                        break;
                }
                return ans
            case 'PUBLIC':
                switch (value) {
                    case 'NO':
                        ans = '關閉瀏覽'
                        break;
                    case 'YES':
                        ans = '開放瀏覽'
                        break;
                    default:
                        // OTHER
                        break;
                }
                return ans
            default:
                // OTHER
                break;
        }
    }

    style_switch_color_tag(name, value) {
        let ans = '#87d068'
        switch (name) {
            case 'LICENSE':
                switch (value) {
                    case 'BOTH':
                        ans = 'olive'
                        break;
                    case 'BYNCSA':
                        ans = 'sienna'
                        break;
                    case 'COPYRIGHT':
                        ans = 'goldenRod'
                        break;
                    default:
                        // OTHER
                        break;
                }
                return ans
            case 'TYPE':
                switch (value) {
                    case 'OTHER':
                        ans = 'magenta'
                        break;
                    case '2D':
                        ans = 'darkSlateBlue'
                        break;
                    case '3D':
                        ans = 'indigo'
                        break;
                    default:
                        // OTHER
                        break;
                }
                return ans
            case 'ORIGINAL':
                switch (value) {
                    case 'BOTH':
                        ans = 'plum'
                        break;
                    case 'NO':
                        ans = 'steelBlue'
                        break;
                    case 'YES':
                        ans = 'darkOrange'
                        break;
                    default:
                        // OTHER
                        break;
                }
                return ans
            case 'PUBLIC':
                switch (value) {
                    case 'NO':
                        ans = 'dimGray'
                        break;
                    case 'YES':
                        ans = 'green'
                        break;
                    default:
                        // OTHER
                        break;
                }
                return ans
            default:
                // OTHER
                break;
        }
    }

    // 操作互動處理 //////////////////////////////////////////////

    resize() {
        this.setState({ deviceWidth: window.innerWidth });
    }

    handle_page_size_change = (current, size) => {
        //console.log(size)
        this.setState({
            pagination: {
                current: current,
                pageSize: size
            }
        }, () => {
            this.api_page_items(current)
        })
    }

    handle_table_change = (pagination, filters, sorter, extra) => {
        if (filters) {
            const status = [...Object.values(filters).filter(Boolean)][0]
            if (status) {
                this.setState({ filterStatus: status }, () => {
                    this.api_page_items(pagination.current)
                });
            } else {
                this.setState({ filterStatus: '' }, () => {
                    this.api_page_items(pagination.current)
                });
            }
        } else {
            this.api_page_items(pagination.current)
        }
    }

    handle_data_refresh = () => {
        this.api_page_items(this.current)
    }

    handle_show_ui_modal = (modal, item) => {
        switch (modal) {
            case 'view':
                this.setState({ isShowModal: true, item })
                // this.api_add_view_log(item)
                break;
            case 'edit':
                this.setState({ isEditModal: true, item })
                break;
            case 'add':
                this.setState({ isAddModal: true })
                break;
            case 'delete':
                const { ObjectCollectionNid } = item
                Modal.confirm({
                    title: `您確定刪除此筆數據`,
                    onOk: () => {
                        this.api_delete_item(ObjectCollectionNid)
                    }
                })
                break;
            case 'download':

                break;
            default:
        }
    }

    handle_pages_next_stautus = (url, item) => {
        // memoryUtils.pagination.isGoNext = true
        const { pageSize, columnSort, orderBy, searchField, searchValue, filterStatus } = this.state
        memoryUtils.pagination.current = this.current
        memoryUtils.pagination.pageSize = pageSize
        memoryUtils.pagination.columnSort = columnSort
        memoryUtils.pagination.orderBy = orderBy
        memoryUtils.pagination.searchField = searchField
        memoryUtils.pagination.searchValue = searchValue
        memoryUtils.pagination.filterStatus = filterStatus

        this.props.history.push(url, item)
    }

    handle_ui_field_change = (target_key, target_field, e) => {
        // const value = e.target.value
        // const item = {
        //     ObjectCollectionNid: target_key,
        //     setPoints: value,
        //     condition: target_field
        // }
        // console.log(target_key)
        // this.api_modify_item(item)

    }

    /////////////////////////////////////////////////////////////     
    render() {
        const { loading, item, items, pagination, searchField, searchValue, isShowModal } = this.state
        const title = (
            <span>
                <Select value={searchField} style={{ width: 120, backgroundColor: 'LightCyan' }} onChange={value => this.setState({ searchField: value })}>
                    <Select.Option value='NONE'>搜索條件</Select.Option>
                    <Select.Option value='ObjectCollectionName'>作品名稱</Select.Option>
                    <Select.Option value='Keyword'>作品標籤</Select.Option>
                </Select>
                <Input placeholder="關鍵字" style={{ width: 80, margin: '0 5px', backgroundColor: 'LightYellow' }} value={searchValue} onChange={event => this.setState({ searchValue: event.target.value })} />
                <Button type='primary' onClick={() => this.api_page_items(1)}><i className="fas fa-search element-hidden"></i><span style={{ marginLeft: '4px' }}>查詢</span></Button>
                {' '}
                <Tooltip placement="top" title="重新整理"><Button type='primary' onClick={() => this.handle_data_refresh()}><i className="fas fa-sync-alt"></i></Button></Tooltip>
                {' '}
            </span>
        )
        const extra = (
            <Alert message="資料來源：文創平台" type="info" showIcon />
        )
        return (
            <Card title={title} extra={extra}>
                <Table
                    bordered
                    scroll={{ y: 480 }}
                    loading={loading}
                    rowKey='ObjectCollectionNid'
                    dataSource={items}
                    onChange={this.handle_table_change}
                    pagination={{
                        ...pagination,
                        responsive: true,
                        showQuickJumper: true,
                        showSizeChanger: true,
                        pageSizeOptions: [5, 10, 20, 50, 100],
                        // onChange: this.api_page_applycase,
                        onShowSizeChange: this.handle_page_size_change
                    }}
                    columns={this.columns}
                />
                <Modal
                    destroyOnClose={true}
                    visible={isShowModal}

                    onOk={() => {
                        this.setState({ isShowModal: false })
                    }}
                    okText={'關閉'}
                    onCancel={() => {
                        this.setState({ isShowModal: false })
                    }}
                    cancelButtonProps={{ style: { display: 'none' } }}
                >
                    <CulturalcreativeWorksShowModal objectCollection={item} />
                </Modal>
            </Card>
        )
    }
}
export default connect(
    state => ({ user: state.user }),
    {}
)(AchievementWorks)